import React, { useState, useEffect } from 'react';
import { tableStyles, isMobile, colors } from '../styles/sharedStyles';

const Table = ({
  columns = [],
  data = [],
  onRowClick,
  loading = false,
  emptyMessage = 'No data available',
}) => {
  const [hoveredRow, setHoveredRow] = useState(null);
  const [isMobileView, setIsMobileView] = useState(false);

  useEffect(() => {
    const checkMobile = () => {
      setIsMobileView(isMobile());
    };

    checkMobile();
    window.addEventListener('resize', checkMobile);

    return () => window.removeEventListener('resize', checkMobile);
  }, []);

  if (loading) {
    return (
      <div style={tableStyles.container}>
        <div style={tableStyles.empty}>Loading...</div>
      </div>
    );
  }

  if (data.length === 0) {
    return (
      <div style={tableStyles.container}>
        <div style={tableStyles.empty}>{emptyMessage}</div>
      </div>
    );
  }

  // Mobile Card View
  if (isMobileView) {
    return (
      <div style={{ display: 'flex', flexDirection: 'column', gap: '12px' }}>
        {data.map((row, rowIndex) => (
          <div
            key={rowIndex}
            onClick={() => onRowClick && onRowClick(row)}
            style={{
              backgroundColor: colors.white,
              borderRadius: '8px',
              boxShadow: '0 2px 4px rgba(0, 0, 0, 0.1)',
              padding: '16px',
              cursor: onRowClick ? 'pointer' : 'default',
              transition: 'box-shadow 0.2s ease',
            }}
            onMouseEnter={(e) => {
              if (onRowClick) {
                e.currentTarget.style.boxShadow = '0 4px 8px rgba(0, 0, 0, 0.15)';
              }
            }}
            onMouseLeave={(e) => {
              e.currentTarget.style.boxShadow = '0 2px 4px rgba(0, 0, 0, 0.1)';
            }}
          >
            {columns.map((column, colIndex) => (
              <div
                key={colIndex}
                style={{
                  marginBottom: colIndex === columns.length - 1 ? '0' : '12px',
                  paddingBottom: colIndex === columns.length - 1 ? '0' : '12px',
                  borderBottom: colIndex === columns.length - 1 ? 'none' : `1px solid ${colors.borderLight}`,
                }}
              >
                <div
                  style={{
                    fontSize: '12px',
                    color: colors.textMuted,
                    marginBottom: '4px',
                    fontWeight: '600',
                    textTransform: 'uppercase',
                  }}
                >
                  {column.header}
                </div>
                <div style={{ fontSize: '14px', color: colors.textPrimary }}>
                  {column.render
                    ? column.render(row[column.accessor], row, rowIndex)
                    : row[column.accessor]}
                </div>
              </div>
            ))}
          </div>
        ))}
      </div>
    );
  }

  // Desktop Table View
  return (
    <div style={tableStyles.container} className="table-container">
      <table style={tableStyles.table}>
        <thead style={tableStyles.thead}>
          <tr>
            {columns.map((column, index) => (
              <th key={index} style={tableStyles.th}>
                {column.header}
              </th>
            ))}
          </tr>
        </thead>
        <tbody style={tableStyles.tbody}>
          {data.map((row, rowIndex) => {
            const isHovered = hoveredRow === rowIndex;
            const trStyle = {
              ...tableStyles.tr,
              ...(isHovered && onRowClick ? tableStyles.trHover : {}),
            };

            return (
              <tr
                key={rowIndex}
                style={trStyle}
                onClick={() => onRowClick && onRowClick(row)}
                onMouseEnter={() => setHoveredRow(rowIndex)}
                onMouseLeave={() => setHoveredRow(null)}
              >
                {columns.map((column, colIndex) => (
                  <td key={colIndex} style={tableStyles.td}>
                    {column.render
                      ? column.render(row[column.accessor], row, rowIndex)
                      : row[column.accessor]}
                  </td>
                ))}
              </tr>
            );
          })}
        </tbody>
      </table>
    </div>
  );
};

export default Table;
